"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var styled_system_1 = require("styled-system");

var theme_get_1 = require("@styled-system/theme-get");

var buttonStretchDisplay = styled_system_1.style({
  prop: 'stretch',
  cssProperty: 'display',
  transformValue: function transformValue(x) {
    return x ? 'block' : 'inline-block';
  }
});
var buttonStretchWidth = styled_system_1.style({
  prop: 'stretch',
  cssProperty: 'width',
  transformValue: function transformValue(x) {
    return x ? '100%' : 'auto';
  }
});
var buttonMinWidth = styled_system_1.style({
  prop: 'size',
  key: 'buttons.buttonSizes',
  cssProperty: 'min-width',
  transformValue: function transformValue(x, scale) {
    return scale[x].minWidth;
  }
});
var buttonPadding = styled_system_1.style({
  prop: 'size',
  key: 'buttons.buttonSizes',
  cssProperty: 'padding',
  transformValue: function transformValue(x, scale) {
    var _a = scale[x],
        py = _a.py,
        px = _a.px;
    return py + " " + px;
  }
});
var buttonFontSize = styled_system_1.style({
  prop: 'size',
  key: 'buttons.buttonSizes',
  cssProperty: 'font-size',
  transformValue: function transformValue(x, scale) {
    return scale[x].fontSize;
  }
});
var buttonRadius = styled_system_1.style({
  prop: 'size',
  key: 'buttons.buttonSizes',
  cssProperty: 'border-radius',
  transformValue: function transformValue(x, scale) {
    return scale[x].radius;
  }
});
var buttonLineHeight = styled_system_1.style({
  prop: 'size',
  key: 'buttons.buttonSizes',
  cssProperty: 'line-height',
  transformValue: function transformValue(x, scale) {
    return scale[x].lineHeight;
  }
}); // TODO

/**
 * - would be nice to have a forced capitalized first letter on button child
 * - the documentation should be better
 * - check again inverted
 */

var getHoverColor = function getHoverColor(props) {
  return props.hoverColor;
};

var getHoverBorder = function getHoverBorder(props) {
  return props.format === 'outlined' && "border: 1px solid " + props.hoverColor + ";";
};

var getDisabledBackground = function getDisabledBackground(props) {
  return props.disabledBackground;
};

var getDisabledBorder = function getDisabledBorder(props) {
  return props.disabledBorder;
};

var getDisabledFontColor = function getDisabledFontColor(props) {
  return props.disabledColor;
};

var getFocusColor = function getFocusColor(props) {
  return props.focusColor;
};

var InnerButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-decoration: none;\n  text-align: center;\n\n  &:focus {\n    outline: 0;\n    -webkit-box-shadow: 0 0 0 4px ", ";\n    -moz-box-shadow: 0 0 0 4px ", ";\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n    ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    border: ", ";\n    color: ", ";\n  }\n"], ["\n  background: transparent;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-decoration: none;\n  text-align: center;\n\n  &:focus {\n    outline: 0;\n    -webkit-box-shadow: 0 0 0 4px ", ";\n    -moz-box-shadow: 0 0 0 4px ", ";\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n    ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    border: ", ";\n    color: ", ";\n  }\n"])), styled_system_1.color, styled_system_1.space, styled_system_1.border, buttonStretchDisplay, buttonStretchWidth, styled_system_1.fontWeight, buttonMinWidth, buttonPadding, buttonFontSize, buttonRadius, buttonLineHeight, getFocusColor, getFocusColor, getFocusColor, getHoverColor, getHoverBorder, getDisabledBackground, getDisabledBorder, getDisabledFontColor);
exports.Button = styled_components_1.withTheme(function (props) {
  var _a;

  var as = props.as,
      size = props.size,
      format = props.format,
      variation = props.variation,
      disabled = props.disabled,
      onClick = props.onClick,
      href = props.href;

  var _b = theme_get_1.themeGet("buttons.buttonStyles." + format)(props),
      colorAttribute = _b.colorAttribute,
      variationRest = __rest(_b, ["colorAttribute"]);

  var buttonColors = theme_get_1.themeGet("buttons.buttonColors." + format + "." + variation)(props);
  var color = buttonColors.default;
  var focusColor = buttonColors.focus;
  var hoverColor = buttonColors.hover;
  var disabledBorder = buttonColors.disabled.border;
  var disabledColor = buttonColors.disabled.color;
  var disabledBackground = buttonColors.disabled.background;

  var variationProps = __assign((_a = {
    color: colorAttribute === 'bg' ? 'white.0' : color
  }, _a[colorAttribute] = color, _a.focusColor = focusColor, _a.hoverColor = hoverColor, _a.disabledBorder = disabledBorder, _a.disabledColor = disabledColor, _a.disabledBackground = disabledBackground, _a), variationRest);

  return react_1.default.createElement(InnerButton, __assign({}, props, variationProps, {
    size: size,
    fontWeight: "semibold",
    onClick: onClick,
    disabled: disabled,
    href: href,
    role: as === 'a' ? 'link' : 'button',
    "aria-disabled": disabled
  }));
});
exports.Button.defaultProps = {
  as: 'button',
  format: 'contained',
  variation: 'primary',
  size: 'md',
  stretch: false
};
exports.Button.displayName = 'Button';
var templateObject_1;